import { CategoriaEvento } from "./categoria.evento.model";
import { Intervento } from "./intervento.model";
import { Utente } from "./utente.model";

export class Evento {
    id: number;
    categoria:CategoriaEvento;

    note:string;
    tecnici:Utente[];
    operatoreRiferimento:Utente;
    accompagnatori:Utente[];
    tecnico:Utente;
    utente:Utente;

    creato:Date;
    modificato:Date;

    inizio:Date;
    fine:Date;

    stato: { id: number, label?: string };

    intervento:Intervento;
    areaCompetenza: {id: string, label?: string};

  }

